export default __webpack_public_path__ + "static/media/1786.8fcefe80.png";